import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-rehab-budget',
  templateUrl: './rehab-budget.component.html',
  styleUrls: ['./rehab-budget.component.scss']
})

export class RehabBudgetComponent implements OnInit {

  totalBudgetAllocated: number = 0;
  
  @Input() rehabBudgetForm: any;
  @Input() rehabTotal: number = 0;

  rehabItems: {
    plans_and_architect: 0,
    structural_engineer_report: 0,
    engineer_report: 0,
    perc_test: 0,
    asbestos_mold_certifications: 0,
    temporary_power: 0,
    survey: 0,
    temporary_utilities: 0,
    erosion_control: 0,
    septic_permit: 0,
    well_permit: 0,
    electric_permit: 0,
    plumbing_permit: 0,
    foundation_permit: 0,
    roof_permit: 0,
    interior_design: 0,
    building_permit: 0,

    excavate_backfill: 0,
    import_export_dirt: 0,
    soil_treatment: 0,
    gas_line: 0,
    gas_materials: 0,
    gas_labor: 0,
    well_install_replacement: 0,
    water_line_public: 0,
    foundation_material: 0,
    foundation_labor: 0,
    structural_steel: 0,
    water_proofing: 0,
    equipment_rental: 0,
    drainage: 0,

    fencing_material: 0,
    fencing_labor: 0,
    pool: 0,
    pool_hardscape: 0,
    landscaping: 0,
    utilities: 0,
    driveway: 0,
    utility_dig: 0,
    other_onsite_work: 0,

    exterior_demo: 0,
    interior_demo: 0,
    other_demo: 0,

    roof_repair_replace: 0,
    siding_1: 0,
    siding_2: 0,
    siding_3: 0,
    siding_4: 0,
    paint_exterior: 0,
    trim_sofit_fascia: 0,
    features_trim: 0,
    gutters_downspouts: 0,
    garage_doors: 0,
    exterior_doors: 0,
    exterior_door_hardware: 0,
    front_port_portico: 0,
    rear_deck_porch_stairs: 0,
    shutters: 0,
    windows: 0,
    exterior_lights: 0,
    other_exterior: 0,

    interior_stairs: 0,
    railings: 0,
    mold_remediation: 0,
    interior_doors: 0,
    interior_door_hardware: 0,
    carpet: 0,
    vinyl: 0,
    ceramic: 0,
    marble: 0,
    hardwood: 0,
    post_repair_cleaning: 0,
    hot_water_heater: 0,
    smoke_detectors: 0,
    carbon_monoxide_detectors: 0,
    smoke_fire_alarms: 0,
    sprinkler_fire_prevention: 0,
    sprinkler_fire_prevention_labor: 0,
    paint_walls_trim: 0,
    light_fixtures: 0,
    drywall: 0,
    framing_material: 0,
    framing_labor: 0,
    electrical_rough: 0,
    electrical_finish: 0,
    electrical_outlets: 0,
    electrical_switches: 0,
    electrical_can_lights: 0,
    sound_system_house: 0,
    security_system: 0,
    vacuum_system: 0,
    fireplace: 0,
    plumbing_rough: 0,
    plumbing_finish: 0,
    sump_pump: 0,
    insulation: 0,
    hvac_install_rough: 0,
    hvac_install_finish: 0,
    hvac_220_volt: 0,
    radiant_heating: 0,
    smart_systems: 0,
    other_interior: 0,

    ceiling_wall_repair: 0,
    fixtures: 0,
    refridgerator: 0,
    dishwasher: 0,
    microwave: 0,
    stove: 0,
    trash_compactor: 0,
    garbage_disposal: 0,
    other_appliances: 0,
    cabinets: 0,
    counters: 0,
    sink_faucet: 0,
    floors: 0,
    other_kitchen: 0,

    bath_1_tub_shower: 0,
    bath_1_toilet: 0,
    bath_1_vanity_top: 0,
    bath_1_cabinets: 0,
    bath_1_floors: 0,
    bath_1_other: 0,

    bath_2_tub_shower: 0,
    bath_2_toilet: 0,
    bath_2_vanity_top: 0,
    bath_2_cabinets: 0,
    bath_2_floors: 0,
    bath_2_other: 0,

    bath_3_tub_shower: 0,
    bath_3_toilet: 0,
    bath_3_vanity_top: 0,
    bath_3_cabinets: 0,
    bath_3_floors: 0,
    bath_3_other: 0,

    misc_cabinet_labor: 0,
    misc_washer_dryer: 0,
    misc_shower_glass: 0,
    misc_iron_works: 0,
    misc_mirrors: 0,
    misc_well_septic_system: 0,
    misc_oil_tank: 0,
    misc_interior_carpentry_trim: 0,

    general_contractor_fee_installment_1: 0,
    general_contractor_fee_installment_2: 0,
    general_contractor_fee_installment_3: 0,
    general_contractor_fee_installment_4: 0,
  }
  
  constructor() { }

  ngOnInit(): void {
    this.rehabItems = {
      plans_and_architect: 0,
      structural_engineer_report: 0,
      engineer_report: 0,
      perc_test: 0,
      asbestos_mold_certifications: 0,
      temporary_power: 0,
      survey: 0,
      temporary_utilities: 0,
      erosion_control: 0,
      septic_permit: 0,
      well_permit: 0,
      electric_permit: 0,
      plumbing_permit: 0,
      foundation_permit: 0,
      roof_permit: 0,
      interior_design: 0,
      building_permit: 0,
  
      excavate_backfill: 0,
      import_export_dirt: 0,
      soil_treatment: 0,
      gas_line: 0,
      gas_materials: 0,
      gas_labor: 0,
      well_install_replacement: 0,
      water_line_public: 0,
      foundation_material: 0,
      foundation_labor: 0,
      structural_steel: 0,
      water_proofing: 0,
      equipment_rental: 0,
      drainage: 0,
  
      fencing_material: 0,
      fencing_labor: 0,
      pool: 0,
      pool_hardscape: 0,
      landscaping: 0,
      utilities: 0,
      driveway: 0,
      utility_dig: 0,
      other_onsite_work: 0,
  
      exterior_demo: 0,
      interior_demo: 0,
      other_demo: 0,
  
      roof_repair_replace: 0,
      siding_1: 0,
      siding_2: 0,
      siding_3: 0,
      siding_4: 0,
      paint_exterior: 0,
      trim_sofit_fascia: 0,
      features_trim: 0,
      gutters_downspouts: 0,
      garage_doors: 0,
      exterior_doors: 0,
      exterior_door_hardware: 0,
      front_port_portico: 0,
      rear_deck_porch_stairs: 0,
      shutters: 0,
      windows: 0,
      exterior_lights: 0,
      other_exterior: 0,
  
      interior_stairs: 0,
      railings: 0,
      mold_remediation: 0,
      interior_doors: 0,
      interior_door_hardware: 0,
      carpet: 0,
      vinyl: 0,
      ceramic: 0,
      marble: 0,
      hardwood: 0,
      post_repair_cleaning: 0,
      hot_water_heater: 0,
      smoke_detectors: 0,
      carbon_monoxide_detectors: 0,
      smoke_fire_alarms: 0,
      sprinkler_fire_prevention: 0,
      sprinkler_fire_prevention_labor: 0,
      paint_walls_trim: 0,
      light_fixtures: 0,
      drywall: 0,
      framing_material: 0,
      framing_labor: 0,
      electrical_rough: 0,
      electrical_finish: 0,
      electrical_outlets: 0,
      electrical_switches: 0,
      electrical_can_lights: 0,
      sound_system_house: 0,
      security_system: 0,
      vacuum_system: 0,
      fireplace: 0,
      plumbing_rough: 0,
      plumbing_finish: 0,
      sump_pump: 0,
      insulation: 0,
      hvac_install_rough: 0,
      hvac_install_finish: 0,
      hvac_220_volt: 0,
      radiant_heating: 0,
      smart_systems: 0,
      other_interior: 0,
  
      ceiling_wall_repair: 0,
      fixtures: 0,
      refridgerator: 0,
      dishwasher: 0,
      microwave: 0,
      stove: 0,
      trash_compactor: 0,
      garbage_disposal: 0,
      other_appliances: 0,
      cabinets: 0,
      counters: 0,
      sink_faucet: 0,
      floors: 0,
      other_kitchen: 0,
  
      bath_1_tub_shower: 0,
      bath_1_toilet: 0,
      bath_1_vanity_top: 0,
      bath_1_cabinets: 0,
      bath_1_floors: 0,
      bath_1_other: 0,
  
      bath_2_tub_shower: 0,
      bath_2_toilet: 0,
      bath_2_vanity_top: 0,
      bath_2_cabinets: 0,
      bath_2_floors: 0,
      bath_2_other: 0,
  
      bath_3_tub_shower: 0,
      bath_3_toilet: 0,
      bath_3_vanity_top: 0,
      bath_3_cabinets: 0,
      bath_3_floors: 0,
      bath_3_other: 0,
  
      misc_cabinet_labor: 0,
      misc_washer_dryer: 0,
      misc_shower_glass: 0,
      misc_iron_works: 0,
      misc_mirrors: 0,
      misc_well_septic_system: 0,
      misc_oil_tank: 0,
      misc_interior_carpentry_trim: 0,
  
      general_contractor_fee_installment_1: 0,
      general_contractor_fee_installment_2: 0,
      general_contractor_fee_installment_3: 0,
      general_contractor_fee_installment_4: 0,
    }

    if (this.rehabBudgetForm) {
      this.rehabItems = this.rehabBudgetForm;
      this.onChange();
    }
  }

  onChange() {
    console.log(`plans and arch = ${this.rehabItems.plans_and_architect}`);
    this.totalBudgetAllocated = 0;
    var keys = Object.keys(this.rehabItems);
    keys.forEach(key => {
      if (key != 'RehabTotalCost') {
        this.totalBudgetAllocated += this.rehabItems[key] != null && this.rehabItems[key] != undefined ? this.rehabItems[key] : 0;
      }
    });

    console.log(this.totalBudgetAllocated);
  }
}
